import type CalculationResultDto from "../../../../dto/calculations/CalculationResultDto";
import type MastResultDto from "../../../../dto/calculations/MastResultDto";
import type ConstructionAllDetailsGuiDto from "../../../../dto/construction/ConstructionAllDetailsGuiDto";
import type BeamDto from "../../../../dto/construction/parts/BeamDto";
import type FoundationDto from "../../../../dto/construction/parts/FoundationDto";
import type MastDto from "../../../../dto/construction/parts/MastDto";
import type ITab from "./types/ITab";
import type IMastTab from "./types/IMastTab";
import type IBeamTab from "./types/IBeamTab";
import type ISpacerTab from "../../../constructionCalculationsNew/components/tabs/types/ISpacerTab";
import type RenderableEditedConstructionPropertyDto from "../../../../dto/calculations/RenderableEditedConstructionPropertyDto";

const useCalculationMastTabsNew = (construction: ConstructionAllDetailsGuiDto | undefined, selectedCalculationResults: CalculationResultDto | undefined): ITab[] => {
    if(!construction) return [];

    let masts = construction.constructionParts.mastParts.masts;
    let beams = construction.constructionParts.beamParts.beams;
    const mastResults = selectedCalculationResults?.mastResults;
    const editedConstructionProperties = selectedCalculationResults?.editedConstructionProperties;

    masts = masts.map((m: MastDto) => {
        const result = mastResults?.find((mr: MastResultDto) => mr.mastId === m.id);
        return {
            ...m,
            profile: {
                ...m.profile,
                value: result?.profile ?? m.profile.value
            }
        };
    });
      
    beams = beams.map((b: BeamDto) => {
        const result = editedConstructionProperties?.find((rcp: RenderableEditedConstructionPropertyDto) => rcp.entityId === b.id && rcp.propertyName.toLocaleLowerCase().includes("type"));
        return {
            ...b,
            type: {
                ...b.type,
                value: result?.newValue as string ?? b.type.value
            } 
        }
    });

    const maxLength = Math.max(mastResults?.length ?? 0, beams.length);
    const partialResult: ITab[] = [];
    const foundations = construction.constructionParts.mastParts.foundations;
    for (let i=0; i < maxLength; ++i) {
        const mastFoundation = foundations.find((f:FoundationDto) => f.mastId.value === masts[i].id);
        const foundationType =
            selectedCalculationResults?.editedConstructionProperties?.find(
            (rcp: RenderableEditedConstructionPropertyDto) => rcp.entityId === mastFoundation?.id)?.newValue as string ?? mastFoundation?.type.value;
        const mastDetails = mastResults && i < mastResults.length? { ...masts[i], ...mastResults[i] } : null;
        const beamDetails = i < beams.length ? beams[i] : null;

        const subResults: ITab[] = [];
        if (mastDetails !== null) {
            const mastTab: IMastTab = {
                number: mastDetails.mastNo,
                profileIsValid: mastDetails.profileIsValid,
                type: mastDetails.profile,
                foundation: mastDetails.foundationType ?? foundationType,
            };
            subResults.push(mastTab);
        }
        if (beamDetails !== null) {
            const beamTab: IBeamTab = {type: beamDetails.type.value};
            subResults.push(beamTab);
        }
    
        if (mastDetails !== null && beamDetails !== null) {
            if ((mastDetails.position.value * 2 - 1) >= beamDetails.compartment.value * 2) {
                subResults.reverse();
            }
        }
    
        partialResult.push(...subResults);
    }

    const result: ITab[] = [];
    partialResult.forEach((element, index) => {
        result.push(element);
        if(index !== partialResult.length -1) {
            const spacerTab: ISpacerTab = { 
                isSpacer: true
            };
            result.push(spacerTab);
        }
    });

    return result;
}

export default useCalculationMastTabsNew;


  